import News from './News.vue';
export default {
  News,
};
